
import React from 'react';
import { Card, CardContent } from "@/components/ui/card";
import { Link } from "react-router-dom";
import { MapPin, Star } from 'lucide-react';
import { motion } from 'framer-motion';
import { Studio } from '@/hooks/use-studios';
import { calculateDistance } from '@/utils/geo-utils';

interface StudioCardProps {
  studio: Studio;
  index: number;
  userLocation?: {
    latitude: number;
    longitude: number;
  };
}

export const StudioCard: React.FC<StudioCardProps> = ({ 
  studio, 
  index, 
  userLocation
}) => {
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ delay: index * 0.1, duration: 0.5 }}
    >
      <Link to={`/studio/${studio.slug || studio.id}`} className="block h-full">
        <Card className="bg-card/50 backdrop-blur-sm hover:bg-card/70 transition-all duration-300 h-full">
          <CardContent className="p-4 flex flex-col gap-2 h-full">
            <div className="flex justify-between items-start mb-1">
              <h3 className="font-semibold text-lg">{studio.name}</h3>
              
              {studio.rating_avg > 0 && (
                <div className="flex items-center gap-1">
                  <Star size={14} className="fill-amber-400 text-amber-400" />
                  <span className="text-sm">{studio.rating_avg.toFixed(1)}</span>
                </div>
              )}
            </div>
            
            {studio.address && (
              <div className="flex items-center gap-1 text-zinc-400 text-xs">
                <MapPin size={12} />
                <span>{studio.address.split(',')[0]}</span>
              </div>
            )}
            
            <p className="text-sm text-zinc-300 line-clamp-2 flex-grow">
              {studio.description || 'Keine Beschreibung verfügbar.'}
            </p>
            
            {userLocation && studio.geo_location && (
              <div className="text-xs text-zinc-400 mt-2">
                <span>
                  {calculateDistance(
                    userLocation.latitude,
                    userLocation.longitude,
                    studio.geo_location.latitude,
                    studio.geo_location.longitude
                  ).toFixed(1)} km entfernt
                </span>
              </div>
            )}
          </CardContent>
        </Card>
      </Link>
    </motion.div>
  );
};
